<template>
  <div>
    <v-card
      flat
    >
      <v-card-title>
        <span style="color: #0074BA">排出事業者情報</span>
      </v-card-title>
      <v-spacer />
      <!-- 排出事業者 -->
      <v-card-text
        v-if="order.emission"
      >
        <!-- 会社名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              会社名
            </div>
            <h4>{{ order.emission.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /会社名 -->
        <!-- 住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>〒{{ order.emission.zip_code }}&emsp;{{ order.emission.address }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /住所 -->
        <!-- 電話番号  -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ order.emission.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号  -->
      </v-card-text>
      <!-- /排出事業者 -->

      <!-- 事業場情報 -->
      <v-card-title>
        <span style="color: #0074BA">排出事業場情報</span>&emsp;
      </v-card-title>
      <v-card-text v-if="order.emission_location">
        <!-- 事業場名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業場名
            </div>
            <h4>{{ order.emission_location.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場名 -->
        <!-- 事業場住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>〒{{ order.emission_location.zip_code }}&emsp;{{ order.emission_location.address }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場住所 -->
        <!-- 電話番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ order.emission_location.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号 -->
      </v-card-text>
      <!-- /事業場情報 -->
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OrderEmissionBlock',
  components: {},
  filters: {},
  mixins: [],
  props: {
    /**
     * @param order { Object }
     * @property order.id {Number} オーダーID
     * @property order.emission { Object }
     * @property order.emission_location { Object }
     * @property order.collection_report { Object }
     */
    order: {
      type: Object,
      default: () => {},
    },
    canShowEditButton: {
      type: Boolean,
      default: () => false,
    },
    deliverers: {
      type: Array,
      default: () => []
    },
    registers: {
      type: Array,
      default: () => []
    },
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss">

table tbody tr {
  cursor: pointer;
}
table tbody tr.v-data-table__selected {
  background: #2196f3 !important;
  color: #fff;
}


</style>
